import { KeyDevsObject } from '@api';
import React from 'react';

import styles from './CompanyEventDrawerContent.module.scss';

export interface CompanyEventDrawerContentProps {
  data: KeyDevsObject;
}

export const CompanyEventDrawerContent = ({
  data,
}: CompanyEventDrawerContentProps) => {
  const { event_type, headline, situation } = data;
  return (
    <div className={styles.container}>
      <div className={styles.eventTypeWrapper}>{event_type}</div>
      <div className={styles.headlineWrapper}>{headline}</div>
      {situation && (
        <div className={styles.situationWrapper} data-testid="situation-label">
          {situation}
        </div>
      )}
    </div>
  );
};
